import { useState } from 'react'
import { BsPower } from 'react-icons/bs'
import { Link, useNavigate } from 'react-router-dom'
import Modal from './Modal'
import useAuth from './../hooks/useAuth'
import { useEffect } from 'react';
import axios from 'axios'
import { get_user, put_user, Logout } from '../api/api'
import Loading from './Loading';
import { toast } from 'react-toastify';
import { memoizedRefreshToken } from '../api/refreshToken'

export default function Profile() {


  const navigate = useNavigate()
  const { auth, setAuth } = useAuth()

  const [nameModal, setNameModal] = useState(false)
  const [shabaModal, setShabaModal] = useState(false)
  const [subdomainModal, setSubdomainModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)
  const [err, setErr] = useState(false)
  const [userData, setUserData] = useState([])
  const [subDomainShow, setSubDomainShow] = useState('')

  const logoutUser = async (event) => {
    event.preventDefault()
    await axios.post(Logout)
    setAuth({})
    localStorage.removeItem('user')
    navigate('/login', { replace: true })
  }

  useEffect(() => {

    const getUserInfo = async () => {

      if (auth?.userId) try {
        setLoading(true)
        const res = await axios.get(get_user(auth?.userId))
        setUserData(res.data)
      } catch (err) { setErr(true) }
        finally { setLoading(false) }

    }

    getUserInfo()

  }, [])



  const handleFirstNameLastName = async (e) => {
    e.preventDefault()
    setButtonLoading(true)

    let data = {
      firstName: e.target.firstName.value,
      lastName: e.target.lastName.value,
      mediaName: e.target.mediaName.value,
      email: e.target.email.value ? e.target.email.value : userData.email,
      shebaNumber: userData.shebaNumber,
      subDomain: userData.subDomain,
      gender: parseInt(e.target.gender.value),
    }

    try {
      const res = await axios.put(put_user, data)
      setUserData(res.data)
      toast.success('اطلاعات با موفقیت ویرایش شد!')
    } finally {
      setButtonLoading(false)
      setNameModal(false)
    }

  }


  const handleNumberSheba = (e) => {
    e.target.value = e.target.value
      .replace(/[^0-9.]/g, '')
      .replace(/(\..*)\./g, '$1')
  }

  const handlesubDomainINput = (e) => {
    e.target.value = e.target.value
      .replace(/[^a-z0-9]/g, '')
      .replace(/(\..*)\./g, '$1')

    setSubDomainShow(e.target.value)
  }

  const handleshebaNumber = async (e) => {
    e.preventDefault()
    setButtonLoading(true)

    let data = {
      firstName: userData.firstName,
      lastName: userData.lastName,
      mediaName: userData.mediaName,
      shebaNumber: e.target.shebaNumber.value,
      email: userData.email,
      subDomain: userData.subDomain,
      gender: userData.gender,
    }

    try {
      const res = await axios.put(put_user, data)
      setUserData(res.data)
      toast.success('اطلاعات با موفقیت ویرایش شد!')
    } finally {
      setButtonLoading(false)
      setShabaModal(false)
    }

  }

  const handleSubDomain = async (e) => {
    e.preventDefault()
    setButtonLoading(true)

    let data = {
      firstName: userData.firstName,
      lastName: userData.lastName,
      mediaName: userData.mediaName,
      shebaNumber: userData.shebaNumber,
      email: userData.email,
      subDomain: e.target.subDomain.value,
      gender: userData.gender,
      roleId: userData.role.id
    }

    try {
      const res = await axios.put(put_user, data)
      setUserData(res.data)

      //refresh Token
      await memoizedRefreshToken();

      toast.success('لینک اختصاصی با موفقیت ثبت شد.')
    } finally {
      setButtonLoading(false)
      setShabaModal(false)
    }
  }


  return (
    <>
      {loading ? <Loading /> : (
        <>
          <Modal
            title='ویرایش اطلاعات شخصی'
            show={nameModal}
            footer={false}
            size='mini'
            onClose={() => setNameModal(false)}
          >

            <form onSubmit={handleFirstNameLastName}>
              <div className="modalPadding">
                <p>درصورتی که تمایل دارید اطلاعات شخصی خود را تغییر
                  دهید مشخصات جدید خود را وارد کنید.</p>
                <input type='text' id='firstName' name='firstName' defaultValue={userData.firstName} placeholder='نام' />
                <input type='text' id='lastName' name='lastName' defaultValue={userData.lastName} placeholder='نام خانوادگی' />
                <input type='text' id='mediaName' name='mediaName' defaultValue={userData.mediaName} placeholder='نام رسانه' />
                <input type='text' id='email' name='email' defaultValue={userData.email} placeholder='ایمیل' />

                <p><label style={{ fontSize: '14px' }}>جنسیت : {' '}
                  <select name="gender" id="gender" required defaultValue={userData.gender ? userData.gender : 0}>
                    <option value="1">مرد</option>
                    <option value="0">زن</option>
                  </select>
                </label></p>
              </div>
              <div className='modal_footer'>
                {buttonLoading ?
                  <button type='button' className='disabled'>لطفا صبر کنید...</button>
                  :
                  <button>ثبت</button>
                }

                <button type='button' onClick={() => setNameModal(false)} className='cancellBtn'>انصراف</button>
              </div>
            </form>
          </Modal>

          <Modal
            title='شماره شبا'
            footer={false}
            show={shabaModal}
            size='mini'
            onClose={() => setShabaModal(false)}
          >
            <form onSubmit={handleshebaNumber}>
              <div className="modalPadding">
                <p>
                  درصورتی که تمایل دارید شماره شبا خود را تغییر دهید فرم زیر را پر کنید.
                </p>
                <input type='text' maxLength={24} minLength={24} onChange={handleNumberSheba} id='shebaNumber' name='shebaNumber' defaultValue={userData.shebaNumber} placeholder='شماره شبا' />
              </div>

              <div className='modal_footer'>
                {buttonLoading ?
                  <button type='button' className='disabled'>لطفا صبر کنید...</button>
                  :
                  <button>ثبت</button>
                }

                <button type='button' onClick={() => setShabaModal(false)} className='cancellBtn'>انصراف</button>
              </div>
            </form>
          </Modal>

          {!userData.subDomain && (
            <Modal
              title='لینک اختصاصی'
              footer={false}
              show={subdomainModal}
              size='mini'
              onClose={() => setSubdomainModal(false)}
            >
              <form onSubmit={handleSubDomain}>

                <div className="modalPadding">
                  <p>نام لینک دلخواه خود را به وارد نمایید.</p>
                  <input type='text' minLength={3} id='subDomain' name='subDomain' onChange={handlesubDomainINput} placeholder='لینک اختصاصی' />
                  {subDomainShow !== '' && (<span style={{ fontWeight: 400, letterSpacing: '1px', color: '#797979' }}>traffic.com/<span style={{ color: '#000' }}>{subDomainShow}</span></span>)}
                </div>

                <div className='modal_footer'>
                  {buttonLoading ?
                    <button type='button' className='disabled'>لطفا صبر کنید...</button>
                    :
                    <button>ثبت</button>
                  }

                  <button type='button' onClick={() => setSubdomainModal(false)} className='cancellBtn'>انصراف</button>
                </div>
              </form>
            </Modal>
          )}


          <div className='contentHolder'>
            <div className='box_radios col-md-12'>

              <div className='rowProfile'>
                <div className='dtr'>
                  <p>نام کاربری</p>
                  <span>{userData.userName}</span>
                </div>
              </div>

              <div className='rowProfile'>
                <div className='dtr'>
                  <p>اطلاعات شخصی</p>
                  <span>{`${userData.firstName ? userData.firstName : ''} ${userData.lastName ? userData.lastName : ''}`} {userData.mediaName && `(${userData.mediaName})`}</span>
                </div>

                {!err && (
                  <div className='dtl'>
                    <button className='' onClick={() => setNameModal(true)}>
                      ویرایش
                    </button>
                  </div>
                )}
              </div>

              {userData?.role?.id !== 4 && <div className='rowProfile'>
                <div className='dtr'>
                  <p>شماره شبا</p>
                  <span>{`IR${userData.shebaNumber ? userData.shebaNumber : ''}`}</span>
                </div>

                {!err && (
                  <div className='dtl'>
                    <button onClick={() => setShabaModal(true)}>ویرایش</button>
                  </div>
                )}
              </div>}

              {userData?.role?.id !== 4 && <div className='rowProfile'>
                <div className='dtr'>
                  <p>لینک اختصاصی</p>
                  {userData.subDomain && <span style={{ letterSpacing: '1px', color: '#000', display: 'flex', direction: 'ltr' }}>sekaans.com/{userData.subDomain}</span>}
                </div>
                {!userData.subDomain && (
                  !err && (
                    <div className='dtl'>
                      <button onClick={() => setSubdomainModal(true)}>ثبت لینک</button>
                    </div>
                  )
                )}
              </div>}

              {userData?.role?.id !== 4 && <div className='rowProfile'>
                <div className='dtr'>
                  <p>لیست تسویه ها</p>
                </div>

                <div className='dtl'>
                  <button onClick={() => navigate('paymenthistory', { replace: true })}>مشاهده</button>
                </div>
              </div>}

              <div className='rowProfile'>
                <div className='dtr'>
                  <Link className='exit' to={'/login'} onClick={logoutUser}>
                    <BsPower />
                    خروج
                  </Link>
                </div>
              </div>
            </div>
          </div>

        </>
      )}

    </>
  )
}
